import React from 'react';

import { courseConst, IContacts } from 'modules/courses';

import SocialMediaBadge from './badge';

interface IProps {
  contacts?: IContacts[];
  className?: string;
  iconMap?: Record<string, JSX.Element>;
}

const MobileBadgeWrapper: React.FC<IProps> = ({ contacts, className, iconMap }) => (
  <div className={className} >
    {contacts?.map(contact => {
      const type = contact.type.toLowerCase() as courseConst.SocialMedias;
      const icon = iconMap?.[type] ?? null;

      return <SocialMediaBadge key={contact.id} url={contact.url} icon={icon} title={contact.type} />;
    })}
  </div>
);

export default MobileBadgeWrapper;
